
import React from 'react';
import { Button } from "@/components/ui/button";
import { useLanguage } from '@/contexts/LanguageContext';

const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();

  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'ar' : 'en');
  };

  const isCurrentlyEn = language === 'en';

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={toggleLanguage}
      className="flex items-center gap-1"
      aria-label={isCurrentlyEn ? 'التبديل إلى العربية' : 'Switch to English'}
    >
      {isCurrentlyEn ? <span lang="ar">العربية</span> : 'English'}
    </Button>
  );
};

export default LanguageSwitcher;
